const getFieldValuesSimpleQuery = (obj: Record<string, unknown>): string[] => {
  const values: string[] = [];

  const extractValues = (data: Record<string, unknown>) => {
    Object.values(data).forEach((value) => {
      if (value && typeof value === 'string') {
        values.push(value);
      } else if (value && typeof value === 'object') {
        extractValues(value as Record<string, unknown>);
      }
    });
  };

  extractValues(obj);
  return values;
};

export default getFieldValuesSimpleQuery;
